import React from 'react'
import './ConfirmDialog.css'
import Pill from '../Pill/Pill'
import { useContext } from 'react'
import { DashboardContext } from '../../Hooks/DashboardContext'
import { DeleteDoc } from '../../firebase/utils'

const ConfirmDialog = () => {

    const {idProduct}=useContext(DashboardContext)

    const Cancel=()=>{
        document.querySelector('.ConfirmDialog').close()
    }
    const Confirm=()=>{

       //alert(idProduct)
       DeleteDoc('Produits',idProduct)
       document.querySelector('.ConfirmDialog').close()


    }

   
    
  return (
    <dialog className='ConfirmDialog'>

        <h1>Confirmation de suppression</h1>

        Voulez-vous  vraiment supprimer ce produit

        <div>
            <Pill bgcolor={'#e8c133'} bordercolor={'transparent'} color={"#fff"} text={'Oui'} onclick={Confirm}/>
            <Pill bgcolor={'red'} bordercolor={'transparent'} color={"#fff"} text={'Non'} onclick={Cancel} />
        </div>
      </dialog>
  )
}

export default ConfirmDialog